const dataProps = props => Object.keys(props).filter(propName => {
  const value = props[propName];

  // don't include non-data attributes
  if (!propName.startsWith('data-')) {
    return false;
  }

  // don't include data attributes with boolean or null-ish values
  // (similar to React ignoring those as children)
  if (value === true || value === false || value === undefined || value === null) {
    return false;
  }

  // throw for invalid data attribute name
  if (typeof document !== 'undefined') {
    const el = document.createElement('div');
    el.setAttribute(propName, '');
  }

  // include data attributes with string or number values
  if (typeof value === 'string' || typeof value === 'number') {
    return true;
  }

  // throw for all other data attribute values
  throw new Error(`Data attribute ${propName} has nonsensical value ${value}`);
}).reduce((acc, propName) => ({
  ...acc,
  [propName]: props[propName]
}), {});
export default dataProps;